import { Dictionary } from '@ngrx/entity';
import { Action, createActionGroup, createFeature, createFeatureSelector, createReducer, on } from '@ngrx/store';
import { FilterGroupTypes, filterPageTypes } from '../../../globals/store/filters.data';
import { userActions } from './user.era';

export const UPDATE_CALENDAR_DATE = '[calendars] update calendar date'
export interface CalendarState {
  calendarDates: Dictionary<Date>
}

const initialStateCreator = (): CalendarState => ({
  calendarDates: {
    [filterPageTypes.home]: new Date(),
    [filterPageTypes.allTasksCalendar]: new Date(),
    [filterPageTypes.tasksCalendar]: new Date(),
  }
})

export const calendarActions = createActionGroup({
  source: 'Calendars',
  events: {
    'Update Calendar Date': (payload: { date: Date, calendarType: keyof FilterGroupTypes }) => payload,
  }
});
export const calendarReducer = createReducer(
  initialStateCreator(),
  on(calendarActions.updateCalendarDate, (state, { date, calendarType }) => {
    const calendarDates = { ...state.calendarDates }
    calendarDates[calendarType] = new Date(date)
    return { ...state, calendarDates }
  }),
  on(userActions.logout, () => initialStateCreator()),
);

export const calendarFeature = createFeature({
  name: 'calendars',
  reducer: calendarReducer,
});

export const calendarStateSelector = createFeatureSelector<CalendarState>('calendars');

